<template>
  <DetailPage ref="detailPage" />
</template>
<script>
import {
  mapGetters,
  mapActions
} from 'vuex';

import DetailPage from './DetailPage';

export default {
  components: {
    DetailPage
  },
  created() {
    this.lastId = this.$route.query.id;
  },
  activated() {
    let newId = this.$route.query.id;
    if (this.lastId != newId) {
      this.lastId = newId;
      this.$refs.detailPage.init();
    }
  }
}
</script>
<style lang="less" scoped>
@import '~styles/book/detail.less';
</style>